// src/vocabulary/C1/unit2/questions.js

const questions = [
  // 🟢 Meaning & understanding
  {
    id: 1,
    type: "choice",
    question: "What does 'inequality' describe?",
    options: [
      "Equal treatment for all",
      "Unfair differences between people",
      "Personal opinions"
    ],
    correctAnswer: "Unfair differences between people"
  },

  {
    id: 2,
    type: "choice",
    question: "Which phrase relates to schools and learning?",
    options: [
      "Social pressure",
      "Education system",
      "Social responsibility"
    ],
    correctAnswer: "Education system"
  },

  // 🟡 Usage & nuance
  {
    id: 3,
    type: "choice",
    question: "Choose the most accurate sentence:",
    options: [
      "Education can reduce social inequality.",
      "Education reduce social inequality.",
      "Education reducing inequality social."
    ],
    correctAnswer: "Education can reduce social inequality."
  },

  {
    id: 4,
    type: "choice",
    question: "Which sentence expresses a social issue?",
    options: [
      "The movie was interesting.",
      "Discrimination affects many people.",
      "The phone is new."
    ],
    correctAnswer: "Discrimination affects many people."
  },

  // 🔵 Critical thinking
  {
    id: 5,
    type: "choice",
    question: "Why is social responsibility important?",
    options: [
      "Because it increases pressure",
      "Because it helps society function better",
      "Because it limits opportunities"
    ],
    correctAnswer: "Because it helps society function better"
  },

  {
    id: 6,
    type: "choice",
    question: "Which sentence best reflects a C1-level discussion?",
    options: [
      "I do not like inequality.",
      "Inequality can limit access to opportunities.",
      "Inequality is bad."
    ],
    correctAnswer: "Inequality can limit access to opportunities."
  }
];

export default questions;


